"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var page_changer_1 = require("../../controls/page-changer");
wp.customize.controlConstructor['epsilon-page-changer'] = wp.customize.Control.extend({
    ready: function () {
        var control = this;
        new page_changer_1.EpsilonPageChanger(control);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/extenders/controls/page-changer.ts
// module id = 20
// module chunks = 0